import React from "react";

export function PageLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="tw-flex tw-max-w-[1440px] tw-h-full tw-flex-col tw-overflow-hidden tw-px-squid-xs mobile-lg:tw-p-squid-m tw-mx-auto tw-w-full">
      {children}
    </div>
  );
}
